const gpsStatus = [
  {
    'key': '1',
    'value': '审核通过'
  },
  {
    'key': '2',
    'value': '审核失败（安装照片数量不足）'
  },
  {
    'key': '3',
    'value': '审核失败（安装照片车型、颜色与系统不符）'
  },
  {
    'key': '4',
    'value': '审核失败（重拍远照）'
  },
  {
    'key': '5',
    'value': '审核失败（重拍近照）'
  },
  {
    'key': '6',
    'value': '审核失败（需更换安装位置）'
  },
  {
    'key': '7',
    'value': '无线不隐蔽，更换安装位置'
  },
  {
    'key': '8',
    'value': '请补充无线安装照片'
  },
  {
    'key': '9',
    'value': 'GPS安装位置不符合要求（GPS设备必须一前一后，有线严禁接发动机舱），重新安装'
  },
  {
    'key': '10',
    'value': '车铭牌与车不符或车架号与系统不符'
  },
  {
    'key': '11',
    'value': '车型与系统不符或车身颜色与系统不符'
  },
  {
    'key': '12',
    'value': 'GPS资料中设备号与系统设备号不符，重新修改核对'
  },
  {
    'key': '13',
    'value': 'GPS申请表有误，重新检查修改'
  },
  {
    'key': '14',
    'value': '有线无轨迹，重新验证'
  },
  {
    'key': '15',
    'value': '无线超时无信号，重新验证'
  },
  {
    'key': '16',
    'value': 'GPS安装照片与其他客户安装照片完全相同'
  },
  {
    'key': '17',
    'value': 'GPS设备号重复使用'
  },
  {
    'key': '18',
    'value': '客户在GPS安装现场'
  },
  {
    'key': '19',
    'value': '无线超时无信号'
  },
  {
    'key': '20',
    'value': '有线无轨迹'
  },
  {
    'key': '100',
    'value': '其他'
  }
]
export {
  gpsStatus
}



// WEBPACK FOOTER //
// ./src/assets/js/page/approval/refs/approve.data.gpsstatus.js